import { InfiniteData } from '@tanstack/react-query';
import { isDy } from 'src/features/components/editComponentPage/EditComponentPage.helper';
import {
  ComponentTypes,
  DyProductSource,
  IComponent,
  PaginationResponse,
} from 'src/interfaces';

export const filterDyComponents = (
  componentsData: InfiniteData<PaginationResponse<IComponent[]>> | undefined,
  suggestedComponentTypes: (ComponentTypes | DyProductSource)[],
): InfiniteData<PaginationResponse<IComponent[]>> | undefined => {
  return componentsData
    ? {
        ...componentsData,
        pages: componentsData?.pages.map((page) => ({
          ...page,
          data: page.data.filter((component) =>
            suggestedComponentTypes?.includes(DyProductSource.DYS) ||
            suggestedComponentTypes?.includes(DyProductSource.DYR)
              ? suggestedComponentTypes?.includes(
                  component.config?.productsSource,
                )
              : !isDy(component.config?.productsSource),
          ),
        })),
      }
    : componentsData;
};
